import { SupportUsMessage } from '@/components/common/SupportUs'
import { useAds } from '@/components/providers/AdsProvider'
import { AD_GLOBAL_STATUS } from '@/defs/ad'
import { cn } from '@/utils/commonUtil'

import styles from './AdUVPPlus.module.scss'

export const AdUVPPlus = () => {
  const { adsDisabled } = useAds()

  if (adsDisabled || !AD_GLOBAL_STATUS.UVPPLUS) return null

  const className = 'mv-video-target mv-video__featured mv-video__optimized'

  return (
    <div className={styles.container}>
      <div
        className={cn(styles.uvpPlus, className)}
        data-autoinsert='true'
        data-automobile='true'
        data-autoplay='true'
        data-disable-jsonld='true'
        data-disable-optimize='true'
        data-muted='true'
        data-playlist-id='upnext'
        data-sticky='true'
      />
      <div className={styles.message}>
        <SupportUsMessage />
      </div>
    </div>
  )
}
